module.exports = __webpack_public_path__ + "static/media/Diggersby_gaussian2.8f86a8f2.png";